export const env: { [s: string]: string | null } = {
  npm_package_version: '1.0.0',
  // API base (overrides serverUrl in environments)
  serverUrl: 'https://app.tbagrosensor.com/public/api/v1',
  // Mapbox token for maps
  mapboxToken:
    'pk.eyJ1IjoiYWxsb21hcnQiLCJhIjoiY21qZXNmNWVwMG1vMzNnc2g1cjk3cXM2YSJ9.u6rwP47Kuca8ZHEGqm7tgQ'
};
